import { FETCH_USER, SET_UPDATING } from './actionTypes';
import store from './reducers';

export function userLoggedIn() {
  return {
    type: FETCH_USER,
  };
}

export function setUpdating(updating) {
  store.dispatch({
    type: SET_UPDATING,
    value: updating,
  });
}
